export const DEFAULT_COUNTRIES_ISO = ['ch', 'de', 'fr', 'li', 'at', 'it'];
